'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stateFromHTML = require('./stateFromHTML');

Object.defineProperty(exports, 'stateFromHTML', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stateFromHTML).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-import-html/lib/main.js
// module id = 1030
// module chunks = 0